import eventType from "@/utils/EventType";
// 共通类
let commonUtil = {

};

// 格式化日期
commonUtil.formatDate = function (da) {
    var date = new Date(da);
    var year = date.getFullYear();
    var mon = date.getMonth() + 1;
    var day = date.getDate();
    var h = date.getHours();
    var m = date.getMinutes();
    var s = date.getSeconds();
    var submitTime = "";
    submitTime += year + "-";
    if (mon >= 10) {
        submitTime += mon + "-";
    } else {
        submitTime += "0" + mon + "-";
    }
    if (day >= 10) {
        submitTime += day;
    } else {
        submitTime += "0" + day;
    }
    submitTime += " ";
    if (h >= 10) {
        submitTime += h + ":";
    } else {
        submitTime += "0" + h + ":";
    }
    if (m >= 10) {
        submitTime += m + ":";
    } else {
        submitTime += "0" + m + ":";
    }
    if (s >= 10) {
        submitTime += s;
    } else {
        submitTime += "0" + s;
    }
    return submitTime
};

// 格式化容量
commonUtil.formatRam = function (num) {
    var type = 0;
    var size = num / 1024;
    var typeName;
    if (size > 1024) {
        size /= 1024;
        type = 1;
    }
    if (size > 1024) {
        size /= 1024;
        type = 2;
    }

    switch (type) {
        case 0:
            typeName = "KB";
            break;
        case 1:
            typeName = "MB";
            break;
        case 2:
            typeName = "GB";
            break;
    }

    return size.toFixed(2) + typeName;
};

// boolean名称中文转换
commonUtil.getBooleanName = function (bool) {
    if (bool) return "是";
    return "否";
};

commonUtil.getDisplayName = function (state) {
    let result = '未定义';
    switch (parseInt(state)) {
        case 1:
            result = "是";
            break;
        case 2:
            result = "否";
            break;
    }
    return result;
};

commonUtil.getShowType = function (state) {
    let result = '未定义';
    switch (parseInt(state)) {
        case 1:
            result = "隐私协议";
            break;
        case 2:
            result = "条件条款";
            break;
        case 3:
            result = "会员细则";
            break;
    }
    return result;
};
commonUtil.getShowName = function (validFlag) {
    let result = '未定义';
    switch (validFlag) {
        case true:
            result = "是";
            break;
        case false:
            result = "否";
            break;
    }
    return result;
};
commonUtil.getDisplaystate = function (state) {
    let result = '';
    switch (parseInt(state)) {
        case 1:
            result = "开启";
            break;
        case 0:
            result = "关闭";
            break;
    }
    return result;
};
commonUtil.getposition = function (state) {
    let result = '';
    if(state=="employee"){
        return result = "店员"
    }else{
        return result = "店长"
    }
};
commonUtil.getMessageStateName = function (state) {
    let result = '未定义';
    switch (parseInt(state)) {
        case 1:
            result = "未审核";
            break;
        case 2:
            result = "已过审";
            break;
        case 3:
            result = "已过审";
            break;
    }
    return result;
};

// 服务器返回消息类型
commonUtil.getMSGType = function (state) {
    let result = "error";
    switch (parseInt(state)) {
        case "I":
            result = "info";
            break;
        case "W":
            result = "warning";
            break;
        case "E":
            result = "error";
            break;
    }
    return result;
};

//通用状态
commonUtil.getStateName = function (state) {
    let result = '未定义';
    switch (parseInt(state)) {
        case 0:
            result = "正常";
            break;
        case 1:
            result = "禁用";
            break;
        case 2:
            result = "删除";
            break;
        case 3:
            result = "提交中";
            break;
        case 4:
            result = "审批中";
            break;
        case 5:
            result = "审批驳回";
            break;
    }
    return result;
};

// 产品状态
commonUtil.getProductStateName = function (state) {
    let result = "未定义";
    switch (parseInt(state)) {
        case 0:
            result = "正常";
            break;
        case 1:
            result = "已下架";
            break;
        case 2:
            result = "不显示";
            break;
    }
    return result;
};

// 推荐标识
commonUtil.getRecommendFlagName = function (flag) {
    let result = "未定义";
    switch (parseInt(flag)) {
        case 0:
            result = "否";
            break;
        case 1:
            result = "是";
            break;
    }
    return result;
};

// 推荐类型名称
commonUtil.getRecommendTypeName = function (type) {
    let result = "未定义";
    switch (parseInt(type)) {
        case 1:
            result = "推荐搜索";
            break;
        case 2:
            result = "推荐活动";
            break;
    }
    return result;
};

// 分类类型
commonUtil.getClassifyTypeName = function (type) {
    let result = "未定义";

    //0父菜单容器型 1商品列表型 2品牌型 3数据结构型
    switch (parseInt(type)) {
        case 0:
            result = "父菜单容器型";
            break;
        case 1:
            result = "商品列表型";
            break;
        case 2:
            result = "品牌型";
            break;
        case 3:
            result = "数据结构型";
            break;
    }
    return result;
};

// 是否walmartGo分类
commonUtil.getWalmartClassifyTypeName = function (type) {
    let result = "未定义";

    //0否 1是
    switch (parseInt(type)) {
        case 0:
            result = "否";
            break;
        case 1:
            result = "是";
            break;
    }
    return result;
};

commonUtil.getTopStateName = function (type) {
    let result = "未定义";

    //状态 0普通 1火热 2新品
    switch (parseInt(type)) {
        case 0:
            result = "普通";
            break;
        case 1:
            result = "火热";
            break;
        case 2:
            result = "新品";
            break;
    }
    return result;
};

commonUtil.getArrowStateName = function (type) {
    let result = "未定义";

    //状态 0普通 1火热 2新品
    switch (parseInt(type)) {
        case 0:
            result = "";
            break;
        case 1:
            result = "↑";
            break;
        case 2:
            result = "↓";
            break;
    }
    return result;
};


// 交换数组item对象的位置
commonUtil.changeItemForArray = function (array, index1, index2) {
    let temp = array[index1]
    array[index1] = array[index2]
    array[index2] = temp
    return array
};

// 获取 item 的 index
commonUtil.getIndexForArray = function (array, target) {
    let index = array.findIndex((item) => {
        if (item == target) {
            return true;
        }
    });
    return index;
};

// 将 item 移至最顶部
commonUtil.setItemToTopForArray = function (array, target) {
    let index = commonUtil.getIndexForArray(array, target);
    if (index == 0) return;
    //先取出,再插入到头部
    array.splice(index, 1);
    array.unshift(target);
};

// 将 item 移至最底部
commonUtil.setItemToBottomForArray = function (array, target) {
    let index = commonUtil.getIndexForArray(array, target);
    if (index == array.length - 1) return;
    //先取出,再插入到尾部
    array.splice(index, 1);
    array.push(target);
};

// 将 item 上移一位
commonUtil.setItemToUpForArray = function (array, target) {
    let index = commonUtil.getIndexForArray(array, target);
    if (index == 0) return array;
    return commonUtil.changeItemForArray(array, index, index - 1);
};

// 将 item 下移一位
commonUtil.setItemToDownForArray = function (array, target) {
    let index = commonUtil.getIndexForArray(array, target);
    if (index == array.length - 1) return array;
    return commonUtil.changeItemForArray(array, index, index + 1);
};

//账号状态
commonUtil.getAccountStateName = function (state) {
    //状态 0正常 1未激活※代创建用户第一次登录需要改密码填资料后才能激活  2被冻结
    switch (state) {
        case 0: return "正常";
        case 1: return "未激活";
        case 2: return "被冻结";
        default: return "未定义"
    }
};

//性别
commonUtil.getGenderName = function (gender) {
    //性别 0 保密 1 男 2 女
    switch (gender) {
        case 0: return "保密";
        case 1: return "男";
        case 2: return "女";
        default: return "未定义";
    }
};

//账号权限
commonUtil.getAccountAuthName = function (auth) {
    //权限 0外部用户 1客服(冻结解冻 需要提交表报 创建app并提交经理审核 可进app协助修改分类商品等)
    //2经理(批准创建app) 3超级管理员(人员维护 进任意app进行任意操作)
    switch (auth) {
        case 0: return "外部用户";
        case 1: return "客服";
        case 2: return "经理";
        case 3: return "超级管理员";
        default: return "未定义";
    }
};

//组织架构通用状态
commonUtil.getOrganizationStateName = function (state) {
    switch (state) {
        case 0: return "普通";
        case 1: return "禁用";
        case 2: return "删除";
        default: return "未定义";
    }
};

//升序
commonUtil.sortAsc = function (a, b, fieldName) {
    if (a[fieldName] > b[fieldName]) {
        return 1;
    } else if (a.sort < b.sort) {
        return -1;
    } else {
        return 0;
    }
};

//降序
commonUtil.sortDes = function (a, b, fieldName) {
    if (a[fieldName] < b[fieldName]) {
        return 1;
    } else if (a.sort > b.sort) {
        return -1;
    } else {
        return 0;
    }
};

export default commonUtil;


// WEBPACK FOOTER //
// ./src/utils/commonUtil.js